var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.featuredPlaylists && _setup.featuredPlaylists.length)?_c('div',[_c('BaseSection',{attrs:{"title":"Featured Playlists"}},[_c(_setup.PlaylistsGridBlock,{attrs:{"playlists":_setup.featuredPlaylists,"type":"playlists","min-tile-width":"160px"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }